import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function CallbackPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/', { replace: true })
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      <p className="mt-4 text-gray-600">{t('common.authenticating')}</p>
    </div>
  )
}
